import i18n, { type Resource } from 'i18next';
import { initReactI18next } from 'react-i18next';

export function initI18n(resources: Resource, defaultNS: string) {
  return i18n.use(initReactI18next).init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    defaultNS,
    interpolation: { escapeValue: false }, // React escapes
  });
}
